
import React from 'react';
import ChildrensDay from 'views/Childrensday1819';

const ChildrensDayPage = () => {
  return <ChildrensDay />;
};

export default ChildrensDayPage;
